export const MKK_GUIDE_ERROR_CODES = [
  "U35101",
  "U35102",
  "U35103",
  "U35104",
  "U35105",
  "U35100",
];

export enum MKK_GUIDE_ERROR_TYPES {
  PHONE_ERROR = "PHONE_ERROR",
  NAME_ERROR = "NAME_ERROR",
  BIRTHDAY_ERROR = "BIRTHDAY_ERROR",
  CITY_ERROR = "CITY_ERROR",
  KPS_ERROR = "KPS_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export enum MKK_GUIDE_ERROR_CODES_ENUM {
  PHONE_ERROR = "U35101",
  NAME_ERROR = "U35102",
  BIRTHDAY_ERROR = "U35103",
  CITY_ERROR = "U35104",
  KPS_ERROR = "U35105",
  UNKNOWN_ERROR = "U35100",
}

export const MKK_GUIDE_ERROR_MAP = {
  U35101: MKK_GUIDE_ERROR_TYPES.PHONE_ERROR,
  U35102: MKK_GUIDE_ERROR_TYPES.NAME_ERROR,
  U35103: MKK_GUIDE_ERROR_TYPES.BIRTHDAY_ERROR,
  U35104: MKK_GUIDE_ERROR_TYPES.CITY_ERROR,
  U35105: MKK_GUIDE_ERROR_TYPES.KPS_ERROR,
  U35100: MKK_GUIDE_ERROR_TYPES.UNKNOWN_ERROR,
};
